import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://ijlqpstnmlbjmitdmzqj.supabase.co";
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY as string;

if (!supabaseKey) {
  console.warn("[supabase] REACT_APP_SUPABASE_PUBLISHABLE_KEY não definido - Auth não funcionará");
}

export const supabase = createClient(supabaseUrl, supabaseKey || "");
